// CB:BEGIN content-limiter
import React from 'react';

type ContentLimiterProps = {
  children: React.ReactNode;
  className?: string;
};

const ContentLimiter: React.FC<ContentLimiterProps> = ({ children, className }) => {
  return <div className={['cb-content', className].filter(Boolean).join(' ')}>{children}</div>;
};

export default ContentLimiter;
// CB:END content-limiter


